import { getLocalizedMessage } from '@/core/shared'
import { markInvalidAttribute, markInvalidAttributeGrops } from '@/core/input_controls/validationError/validationError'
import { formatNumberReverse } from '@/core/item_assistance/generatingDifferentialJson'

var numberAttributeError = ''
var outOfRangeNumberError = ''
var longStringError = ''

export function runValidation (data, itemConfig, contextSelector) {
	numberAttributeError = getLocalizedMessage('attribute.must.contain.numbers')
	outOfRangeNumberError = getLocalizedMessage('the.number.is.out.of.range')
	longStringError = getLocalizedMessage('the.length.of.the.string.is.longer.than.allowed')

	var isValidN = true, isValidS = true, isValidNM = true, isValidSL = true

	_.each(data, function (value, key) {
		var config = itemConfig[key.split('__')[0]]
		switch (config['type']) {
			case 'N': {
				(isValidN) ? isValidN = validateN(value, config, key, contextSelector) : validateN(value, config, key, contextSelector)
				break
			}
			case 'S': {
				(isValidS) ? isValidS = validateS(value, config, key, contextSelector) : validateS(value, config, key, contextSelector)
				break
			}
			case 'NM': {
				(isValidNM) ? isValidNM = validateNM(value, config, key, contextSelector) : validateNM(value, config, key, contextSelector)
				break
			}
			case 'SL': {
				(isValidSL) ? isValidSL = validateSL(value, config, key, contextSelector) : validateSL(value, config, key, contextSelector)
				break
			}
			default: {
				break
			}
		}
	})

	markInvalidAttributeGrops()

	return (isValidN && isValidS && isValidNM && isValidSL)
}

function validateN (attributeValue, attributeConfig, attributeName, contextSelector) {
	var isValid = true
	var context = contextSelector ? (contextSelector + ' ') : ''

	if (!attributeConfig['multiple']) {
		if (attributeValue != null) {
			attributeValue = +formatNumberReverse(String(attributeValue))
			if (!isNumber(attributeValue)) {
				markInvalidAttribute(context + '#' + attributeName, numberAttributeError)
				isValid = false
			} else if (!isNotOverflowNumber(attributeValue)) {
				markInvalidAttribute(context + '#' + attributeName, outOfRangeNumberError)
				isValid = false
			}
		}
	} else {
		if (attributeValue != null) {
			_.each(attributeValue, function (value, index) {
				value = +formatNumberReverse(String(value))
				if (!isNumber(value)) {
					markInvalidAttribute(context + '#' + attributeName + '__' + index, numberAttributeError)
					isValid = false
				} else if (!isNotOverflowNumber(value)) {
					markInvalidAttribute(context + '#' + attributeName + '__' + index, outOfRangeNumberError)
					isValid = false
				}
			})
		}
	}
	return isValid
}

function validateS (attributeValue, attributeConfig, attributeName, contextSelector) {
	var isValid = true
	var context = contextSelector ? (contextSelector + ' ') : ''

	if (!attributeConfig['multiple']) {
		if (attributeValue != null) {
			if (!isEnterMaxLength(attributeValue, attributeConfig)) {
				markInvalidAttribute(context + '#' + attributeName, longStringError)
				isValid = false
			}
		}
	} else {
		if (attributeValue != null) {
			_.each(attributeValue, function (value, index) {
				if (!isEnterMaxLength(value, attributeConfig)) {
					markInvalidAttribute(context + '#' + attributeName + '__' + index, longStringError)
					isValid = false
				}
			})
		}
	}
	return isValid
}

function validateNM (attributeValue, attributeConfig, attributeName, contextSelector) {
	var isValid = true
	var context = contextSelector ? (contextSelector + ' ') : ''

	if (!attributeConfig['multiple']) {
		if (attributeValue != null) {
			attributeValue['val'] = +formatNumberReverse(String(attributeValue['val']))
			if (!isNumber(attributeValue['val'], attributeConfig)) {
				markInvalidAttribute(context + '#' + attributeName, numberAttributeError)
				isValid = false
			} else if (!isNotOverflowNumber(attributeValue['val'], attributeConfig)) {
				markInvalidAttribute(context + '#' + attributeName, outOfRangeNumberError)
				isValid = false
			}
		}
	} else {
		if (attributeValue != null) {
			_.each(attributeValue, function (value, index) {
				value['val'] = +formatNumberReverse(String(value['val']))
				if (!isNumber(value['val'], attributeConfig)) {
					markInvalidAttribute(context + '#' + attributeName + '__' + index, numberAttributeError)
					isValid = false
				} else if (!isNotOverflowNumber(value['val'], attributeConfig)) {
					markInvalidAttribute(context + '#' + attributeName + '__' + index, outOfRangeNumberError)
					isValid = false
				}
			})
		}
	}
	return isValid
}

function validateSL (attributeValue, attributeConfig, attributeName, contextSelector) {
	var isValid = true
	var context = contextSelector ? (contextSelector + ' ') : ''

	if (!attributeConfig['multiple']) {
		if (attributeValue != null) {
			_.each(attributeValue, function (value, key) {
				if (!isEnterMaxLength(value, attributeConfig)) {
					markInvalidAttribute(context + '#' + attributeName + '__' + key, longStringError)
					isValid = false
				}
			})
		}
	}
	return isValid
}

function isNumber (value) {
	return (_.isEmpty(value)) ? true : $.isNumeric(value)
}

function isNotOverflowNumber (value) {
	if (!_.isEmpty(value) && !isNumericExp(value)) {
		var FRACTIONAL_LENGTH_LIMIT = 4
		var DP_DIGITS_LIMIT = 15
		var DELIMITER = '.'

		var parts = value.toString().split(DELIMITER)
		var integerPart = parts[0] ? parts[0].replace(/^[0]*/, '') : parts[0]
		var fractionalPart = parts[1] ? parts[1].replace(/[0]*$/, '') : parts[1]

		if (_.isUndefined(fractionalPart) || fractionalPart.length === 0) {
			if (+integerPart > Number.MAX_SAFE_INTEGER) {
				return false
			}
		} else {
			if (fractionalPart.length > FRACTIONAL_LENGTH_LIMIT) {
				return false
			} else {
				if (integerPart.length + fractionalPart.length > DP_DIGITS_LIMIT) {
					return false
				}
			}
		}
	}
	return true

	//is valid after checking by isNumber
	function isNumericExp (value) {
		return value && (value.indexOf('e') > -1 || value.indexOf('E') > -1)
	}
}

function isEnterMaxLength (value, config) {
	return (config['maxLength']) ? (value.length <= config['maxLength']) : true
}
